import type { IInputTask } from './IInputTask';
import { GeoJsonGeometry } from '../types/GeoJSONTypes';

export enum InputType {
  Reserved = 0,
  PlanActual = 1,
  Recommendation = 2,
}

export enum ZoneLinkType {
  Reserved = 0,
  Organisation = 1,
  Farm = 2,
  Paddock = 3,
  GPSLocation = 4,
  Zone = 5,
}

export interface IUnit {
  unit: string;
  globalId: string | null;
}

export interface IDocumentReference {
  docId: string;
  docType: number;
  refDocName?: string | null;
  refDateModified?: string;
  refModifierId?: string | null;
  refModifier?: string | null;
  refStartDate?: string | null;
  refEndDate?: string | null;
  dateCopied?: string;
  operatorId: string | null;
  snapOperator: string | null;
  copyMode?: number;
  copiedTaskCount?: number | null;
  snapDocName?: string | null;
  taskId?: string | null;
}

export interface IVariety {
  varietyName: string;
  globalId: string | null;
}

export interface ICrop {
  cropName: string;
  globalId: string | null;
  variety: IVariety | null;
}

export interface IItem {
  item: string;
  globalId: string | null;
}

export interface IInputWithholdPeriod {
  item: string;
  globalId: string | null;
  period: number | null;
  freeDate: string | null;
}

export interface IInputWithholdPeriodReference {
  item: string;
  globalId: string | null;
  period: number | null;
}

export interface ILink {
  linkType: ZoneLinkType;
  linkId: string;
  snapLinkName: string | null;
}

export type IGeoData = GeoJsonGeometry;

export interface IInputZone {
  zoneName: string;
  zoneArea: number;
  areaUnit: IUnit | null;
  geoData: IGeoData | null;
  links: ILink[];
}

export interface IFile {
  fileId: string;
  fileType: number;
  mimeType: string | null;
  fileData: string | null;
  fileLink: string | null;
}

export interface IChat {
  chatId: string;
  dateCreated: string;
  dateModified: string;
  senderId: string | null;
  snapSender: string | null;
  message: string;
  files: IFile[];
}

export interface IOperator {
  userName: string;
  userId: string | null;
  snapFirstName: string | null;
  snapLastName: string | null;
  snapPreferredName: string | null;
}

export interface INozzle {
  nozzleSize: string | null;
  brand: string | null;
  model: string | null;
  dropletSize: number;
  sprayQuality: string | null;
  pressure: number | null;
  pressureUnit: IUnit | null;
}

export interface IWeatherStat {
  dateReported: string | null;
  dateModified: string;
  modifierId: string | null;
  snapModifier: string | null;
  windDirection: IItem;
  windSpeed: number | null;
  windSpeedUnit: IUnit | null;
  temperature: number | null;
  temperatureUnit: IUnit;
  humidity: number | null;
  humidityUnit: IUnit | null;
  rain: number | null;
  rainUnit: IUnit | null;
  deltaT: number | null;
  deltaTUnit: IUnit | null;
}

export interface IInput {
  id: string;
  version: number;
  dateCreated: string;
  creatorId: string | null;
  snapCreator: string | null;
  dateModified: string | null;
  modifierId: string | null;
  snapModifier: string | null;
  sourceId: string;
  isActive: boolean;
  orgId: string;
  startDate: string | null;
  endDate: string | null;
  docName: string | null;
  notes: string | null;
  inputType: InputType;
  copyFrom: IDocumentReference[];
  copyTo: IDocumentReference[];
  zone: IInputZone | null;
  crop: ICrop;
  tasks: IInputTask[];
}
